import React from 'react';
import { Stack } from '@fiverr-private/layout_components';
import { Popover, PopoverAnchor, PopoverContent } from '@fiverr-private/popover';
import { Typography } from '@fiverr-private/typography';
import { Box } from '@fiverr-private/theme';
import { appTranslate } from '../../../i18n';
import { GradientBadge } from '../../gradients/gradientBadge/GradientBadge';
import { reportAiDeliveryBadgeHoverEvent } from '../../../utils/reportBiEvent/reportAiDeliveryBadgeHoverEvent';
import * as style from './AiDeliveryBadge.ve.css';
import { AiDeliveryBadgeProps } from './AiDeliveryBadge.types';

const Badge: React.FC<{ gradientColors: string[] }> = ({ gradientColors }) => {
    const text = appTranslate('badges.ai_delivery_badge.text');

    return (
        <Stack alignItems="center" gap="1.5" height="20px">
            <Box width={20} height={20} borderRadius="md">
                <GradientBadge colors={gradientColors} degrees="55" />
            </Box>
            <Typography className={style.badgeText} fontSize="b_sm" fontWeight="semibold" lineHeight="b_sm">
                {text}
            </Typography>
        </Stack>
    );
};
Badge.displayName = 'Badge';

const AiDeliveryBadge: React.FC<AiDeliveryBadgeProps> = ({
    gradientColors,
    tooltipContent,
    popoverContentProps,
    biEventData,
}) => {
    const onHover = (isOpen: boolean) => {
        if (isOpen) {
            reportAiDeliveryBadgeHoverEvent(biEventData);
        }
    };

    if (tooltipContent) {
        return (
            <Popover position="bottom-start" triggerEvent="hover" offset={0} onOpenChanged={onHover}>
                <PopoverAnchor>
                    <Badge gradientColors={gradientColors} />
                </PopoverAnchor>
                <PopoverContent {...popoverContentProps}>{tooltipContent}</PopoverContent>
            </Popover>
        );
    }

    return <Badge gradientColors={gradientColors} />;
};
AiDeliveryBadge.displayName = 'AiDeliveryBadge';
export default AiDeliveryBadge;
